import React from 'react'

export default function About() {
  return (
    <div className='container'>
      <div className='row'>
        <div className='col align-self-center'>
          <img 
            className='img-fluid'
            src='https://storage.googleapis.com/sgdic-f6ed1.appspot.com/carousel/istockphoto-1273109788-612x612.jpeg' alt='COMING SOON!!'/>
        </div>
      </div>
    </div>
  )
}
